import { render, staticRenderFns } from "./regional_analysis.vue?vue&type=template&id=425f6b42&scoped=true"
import script from "./regional_analysis.vue?vue&type=script&lang=js"
export * from "./regional_analysis.vue?vue&type=script&lang=js"
import style0 from "./regional_analysis.vue?vue&type=style&index=0&id=425f6b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f6b42",
  null
  
)

export default component.exports